import { css } from 'lit';

export const labelOnDarkStyles = css`
  --_label__border--focus: var(--sbkLabelOnDarkFocus);
  --_label__color: var(--sbkLabelFgColorOnDarkDefault);
  --_label__color--disabled: var(--sbkLabelFgColorOnDarkDisabled);
  --_label__color--error: var(--sbkLabelFgColorOnDarkError);
`;
